import { render, staticRenderFns } from "./add-brand.vue?vue&type=template&id=59257e30&scoped=true&"
import script from "./add-brand.vue?vue&type=script&lang=js&"
export * from "./add-brand.vue?vue&type=script&lang=js&"
import style0 from "./add-brand.vue?vue&type=style&index=0&id=59257e30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59257e30",
  null
  
)

export default component.exports